import axios from "axios";
import { environment } from "../../environments/environment";

const API_BASE_NAME = `${environment.apiBaseUrl}`;

const authHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  },
});

/* 🔹 CREATE / UPDATE MENU ACCESS */
export const createMenuAccess = async (payload: any) => {
  const res = await axios.post(
    `${API_BASE_NAME}/admin/menu-access`,
    payload,
    authHeader()
  );

  return res.data;
};

/* 🔹 GET ALL MENU ACCESS */
export const getAllMenuAccess = async () => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/menu-access`,
    authHeader()
  );

  return res.data;
};

/* 🔹 GET MENU + DEFAULT ACCESS */
export const getMenuWithAccess = async () => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/menu-access/menu`,
    authHeader()
  );

  return res.data;
};

/* 🔹 GET MENU ACCESS BY ROLE */
export const getMenuAccessByRole = async (roleId: number) => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/menu-access/${roleId}`,
    authHeader()
  );

  return res.data;
};

/* 🔹 GET ONLY ALLOWED MENUS (SIDEBAR) */
export const getAllowedMenus = async (roleId: number) => {
  const res = await axios.get(
    `${API_BASE_NAME}/admin/menu-access/allowed/${roleId}`,
    authHeader()
  );

  return res.data;
};